import { useRouter } from 'next/router'
import { Trans } from 'next-i18next'

import {
  Heading3,
  LinkText,
  Paragraph,
  Section3
} from '@/features/Listings/seo/elements'
import getFilterLinks from '@/features/Listings/seo/search-results-content/content/get-filter-links'
import useFilterSlug from '@/features/Listings/seo/search-results-content/content/use-filter-slug'

const AverageRentFaq = ({
  filterSlug,
  isCanadaPage = false,
  cityName,
  cityNameWithState,
  citySlug,
  neighbourhoodSlug,
  rentAmounts,
  rentReportCity,
  rentReportLink,
  rentReportLinkZh
}) => {
  const router = useRouter()
  const isChinese = router.locale === 'zh'
  const links = getFilterLinks(isCanadaPage, citySlug, neighbourhoodSlug)
  const { hasFilter, filterName } = useFilterSlug(filterSlug)

  const localizedReportLink =
    isChinese && rentReportLinkZh ? rentReportLinkZh : rentReportLink

  return (
    <>
      {hasFilter ? (
        <Section3>
          <Heading3>
            <Trans
              i18nKey="seo:What is the average rent in LOCATION for FILTER?"
              values={{
                filter: filterName,
                location: cityName
              }}
              defaults="What is the average rent in {{ location }} for {{ filter }}?"
            />
          </Heading3>
          <Paragraph>
            <Trans i18nKey="seo:Average rent in LOCATION for FILTER custom paragraph">
              The average rent in {{ cityNameWithState }} for {{ filterName }}{' '}
              will vary on a month-to-month basis. For the latest stats on
              average rent in {{ cityName }}, check out our monthly{' '}
              <LinkText href={rentReportLink}>
                {{ rentReportCity }} rent reports
              </LinkText>
              .
            </Trans>
          </Paragraph>
        </Section3>
      ) : (
        <>
          <Section3>
            <Heading3>
              <Trans
                i18nKey="seo:What is the average rent for 1 bedroom apartment LOCATION?"
                values={{
                  location: cityName
                }}
                defaults="What is the average rent for 1 bedroom apartment {{ location }}?"
              />
            </Heading3>
            <Paragraph>
              <Trans i18nKey="seo:Average Rent 1 Bed CITY Paragraph">
                The average rent for a{' '}
                <LinkText href={links.bed1}>
                  1 bedroom apartment in {{ cityNameWithState }}
                </LinkText>{' '}
                is between {{ rentAmounts: rentAmounts.bed1 }}. To stay up to
                date on the{' '}
                <LinkText href={localizedReportLink}>
                  average rent in {{ cityName }}
                </LinkText>
                , check out our monthly{' '}
                <LinkText href={localizedReportLink}>
                  {{ rentReportCity }} rent reports
                </LinkText>
                .
              </Trans>
            </Paragraph>
          </Section3>
          <Section3>
            <Heading3>
              <Trans
                i18nKey="seo:What is the average rent for 2 bedroom apartment LOCATION?"
                values={{
                  location: cityName
                }}
                defaults="What is the average rent for 2 bedroom apartment {{ location }}?"
              />
            </Heading3>
            <Paragraph>
              <Trans i18nKey="seo:Average Rent 2 Bed CITY Paragraph">
                The average rent for a{' '}
                <LinkText href={links.bed2}>
                  2 bedroom apartment in {{ cityNameWithState }}
                </LinkText>{' '}
                is between {{ rentAmounts: rentAmounts.bed2 }}. To stay up to
                date on the{' '}
                <LinkText href={localizedReportLink}>
                  average rent in {{ cityName }}
                </LinkText>
                , check out our monthly{' '}
                <LinkText href={localizedReportLink}>
                  {{ rentReportCity }} rent reports
                </LinkText>
                .
              </Trans>
            </Paragraph>
          </Section3>
          <Section3>
            <Heading3>
              <Trans
                i18nKey="seo:What is the average rent for 3 bedroom apartment LOCATION?"
                values={{
                  location: cityName
                }}
                defaults="What is the average rent for 3 bedroom apartment {{ location }}?"
              />
            </Heading3>
            <Paragraph>
              <Trans i18nKey="seo:Average Rent 3 Bed CITY Paragraph">
                The average rent for a{' '}
                <LinkText href={links.bed3}>
                  3 bedroom apartment in {{ cityNameWithState }}
                </LinkText>{' '}
                is between {{ rentAmounts: rentAmounts.bed3 }}. To stay up to
                date on the{' '}
                <LinkText href={localizedReportLink}>
                  average rent in {{ cityName }}
                </LinkText>
                , check out our monthly{' '}
                <LinkText href={localizedReportLink}>
                  {{ rentReportCity }} rent reports
                </LinkText>
                .
              </Trans>
            </Paragraph>
          </Section3>
        </>
      )}
    </>
  )
}

export default AverageRentFaq
